import { Injectable } from '@angular/core';
import { DataService } from './core/data.service';

@Injectable({ providedIn: 'root' })
export class RastrearProtocoloService extends DataService {
    context = 'rastrearprotocolo';

    public obterCabecalhoRastreioProtocolo(id: number) {
        return this.get<any>(`${id}`);
    }

    public obterHistoricoProtocolo(idProtocolo: number) {
        return this.get<string>(`${idProtocolo}/historico`);
    }

}
